export {default as bin} from './src/bin';
export {default as bootstrapCI} from './src/bootstrapCI';
export {default as quartiles} from './src/quartiles';
export {random, setRandom} from './src/random';
export {default as randomLCG} from './src/lcg';
export {default as randomInteger} from './src/integer';
export {default as randomKDE} from './src/kde';
export {default as randomMixture} from './src/mixture';
export {default as randomNormal} from './src/normal';
export {default as randomUniform} from './src/uniform';
export {default as regressionLinear} from './src/regression/linear';
export {default as regressionLog} from './src/regression/log';
export {default as regressionExp} from './src/regression/exp';
export {default as regressionPow} from './src/regression/pow';
export {default as regressionQuad} from './src/regression/quad';
export {default as regressionPoly} from './src/regression/poly';
export {default as regressionLoess} from './src/regression/loess';
export {default as sampleCurve} from './src/sampleCurve';
